import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AdminPermissionsProvider } from '../../context/AdminPermissionsContext';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import AdminReadOnlyBanner from './AdminReadOnlyBanner';
import AdminRouteGuard from './AdminRouteGuard';
import { useAdminPermissions } from '../../hooks/useAdminPermissions';

const AdminLayoutInner = ({ sidebarOpen, closeSidebar, toggleSidebar, pathname }) => {
  const { isViewer } = useAdminPermissions();

  return (
    <div
      className={`admin-layout admin-layout--premium admin-layout--dash storefront-root d-flex${isViewer ? ' admin-layout--readonly' : ''}`}
    >
      <AdminSidebar isOpen={sidebarOpen} onClose={closeSidebar} pathname={pathname} />

      <div className="adm-shell flex-grow-1 d-flex flex-column min-vh-100">
        <AdminHeader onMenuToggle={toggleSidebar} />
        <AdminReadOnlyBanner />
        <div className="admin-content adm-main">
          <div className="admin-content-inner">
            <AdminRouteGuard>
              <Outlet />
            </AdminRouteGuard>
          </div>
        </div>
      </div>
    </div>
  );
};

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <AdminPermissionsProvider>
      <AdminLayoutInner
        sidebarOpen={sidebarOpen}
        closeSidebar={closeSidebar}
        toggleSidebar={toggleSidebar}
        pathname={location.pathname}
      />
    </AdminPermissionsProvider>
  );
};

export default AdminLayout;
